/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IWorkFlowStep } from 'app/shared/model/work-flow-step.model';
import { IWorkFlowProtocolLog } from 'app/shared/model/work-flow-protocol-log.model';

export interface IWorkFlowStepLog {
  id?: string;
  value?: string;
  notes?: string | null;
  completedById?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  completedByType?: IClinicalDictionary | null;
  step?: IWorkFlowStep | null;
  protocol?: IWorkFlowProtocolLog | null;
}

export const defaultValue: Readonly<IWorkFlowStepLog> = {
  active: false,
};
